import { gql } from "graphql-tag";

import FollowedListFragment from "queries/followed_lists/fragments/FollowedListFragment";
import FollowedPromptFragment from "queries/followed_prompts/fragments/FollowedPromptFragment";
import FollowedUserFragment from "queries/followed_users/fragments/FollowedUserFragment";
import UserBookStatusFragment from "queries/user_books/fragments/UserBookStatusFragment";
import OwnerFragment from "queries/users/fragments/OwnerFragment";

import AuthorBylineFragment from "./authors/fragments/AuthorBylineFragment";
import AuthorFragment from "./authors/fragments/AuthorFragment";
import BookCharacterFragment from "./book_characters/fragments/BookCharacterFragment";
import BookMappingFragment from "./book_mappings/fragments/BookMappingFragment";
import BookBylineFragment from "./books/fragments/BookBylineFragment";
import BookEditFragment from "./books/fragments/BookEditFragment";
import BookFragment from "./books/fragments/BookFragment";
import BookSeriesFragment from "./books/fragments/BookSeriesFragment";
import CharacterFragment from "./characters/fragments/CharacterFragment";
import CollectionImportFragment from "./collection_imports/fragments/CollectionImportFragment";
import CollectionImportResultFragment from "./collection_imports/fragments/CollectionImportResultFragment";
import CountryFragment from "./countries/fragments/CountryFragment";
import EditEditionFragment from "./editions/fragments/EditEditionFragment";
import EditionFragment from "./editions/fragments/EditionFragment";
import ActivityFragment from "./feed/fragments/ActivityFragment";
import GoalFragment from "./goals/fragments/GoalFragment";
import ImageFragment from "./images/fragments/ImageFragment";
import ReadingJournalFragment from "./journals/fragments/ReadingJournalFragment";
import ReadingJournalSummaryFragment from "./journals/fragments/ReadingJournalSummaryFragment";
import LanguageFragment from "./languages/fragments/LanguageFragment";
import LikeFragment from "./likes/fragments/LikeFragment";
import ListBookFragment from "./listBooks/fragments/ListBookFragment";
import ListBylineFragment from "./lists/fragments/ListBylineFragment";
import ListFragment from "./lists/fragments/ListFragment";
import NotificationDeliveryFragment from "./notifications/fragments/NotificationDeliveryFragment";
import NotificationFragment from "./notifications/fragments/NotificationFragment";
import NotificationTypeFragment from "./notifications/fragments/NotificationTypeFragment";
import PromptAnswerFragment from "./prompts/fragments/PromptAnswerFragment";
import PromptBookSummaryFragment from "./prompts/fragments/PromptBookSummaryFragment";
import PromptFragment from "./prompts/fragments/PromptFragment";
import PublisherFragment from "./publishers/fragments/PublisherFragment";
import MatchPercentageFragment from "./recommendations/fragments/MatchPercentageFragment";
import SeriesFragment from "./series/fragments/SeriesFragment";
import TagFragment from "./tags/fragments/TagFragment";
import TaggingFragment from "./tags/fragments/TaggingFragment";
import UserBlockFragment from "./user_blocks/fragments/UserBlockFragment";
import UserBookReadFragment from "./user_book_reads/fragments/UserBookReadFragment";
import UserBookFragment from "./user_books/fragments/UserBookFragment";
import UserBookFullFragment from "./user_books/fragments/UserBookFullFragment";
import UserBylineFragment from "./users/fragments/UserBylineFragment";
import UserInfoFragment from "./users/fragments/UserInfoFragment";

export default gql`
  ${ActivityFragment}
  ${AuthorBylineFragment}
  ${AuthorFragment}
  ${BookBylineFragment}
  ${BookEditFragment}
  ${BookCharacterFragment}
  ${BookFragment}
  ${BookMappingFragment}
  ${BookSeriesFragment}
  ${CharacterFragment}
  ${CollectionImportFragment}
  ${CollectionImportResultFragment}
  ${CountryFragment}
  ${EditEditionFragment}
  ${EditionFragment}
  ${FollowedListFragment}
  ${FollowedPromptFragment}
  ${FollowedUserFragment}
  ${GoalFragment}
  ${ImageFragment}
  ${LanguageFragment}
  ${LikeFragment}
  ${ListFragment}
  ${ListBookFragment}
  ${ListBylineFragment}
  ${MatchPercentageFragment}
  ${NotificationDeliveryFragment}
  ${NotificationFragment}
  ${NotificationTypeFragment}
  ${OwnerFragment}
  ${PromptAnswerFragment}
  ${PromptFragment}
  ${PublisherFragment}
  ${ReadingJournalFragment}
  ${ReadingJournalSummaryFragment}
  ${SeriesFragment}
  ${TagFragment}
  ${TaggingFragment}
  ${UserBlockFragment}
  ${UserBookFragment}
  ${UserBookFullFragment}
  ${UserBookReadFragment}
  ${UserBookStatusFragment}
  ${UserBylineFragment}
  ${UserInfoFragment}
  ${PromptBookSummaryFragment}
`;
